import React, { FC } from 'react';
import { ToggleButton, ToggleButtonProps } from '../ToggleButton';

type ChosenToggleButtonProps = Omit<ToggleButtonProps, 'children'>;

export const AddedToggleButton: FC<ChosenToggleButtonProps> = (props) => (
  <ToggleButton {...props} isSmall selectedText="Added" setWidth={90}>
    Add
  </ToggleButton>
);
